import { createBrowserHistory } from "history";

// create browser history
export const history = createBrowserHistory();
